import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppShell, ProtectedRoute } from '@/components/layout';

// Every page is its own lazy module with a default export: Wave B overwrites that one file,
// the route tree and nav below never need to change.
const Login = lazy(() => import('./pages/auth/login'));
const Overview = lazy(() => import('./pages/overview'));
const Prospects = lazy(() => import('./pages/prospects/list'));
const ProspectDetail = lazy(() => import('./pages/prospects/detail'));
const Enrichment = lazy(() => import('./pages/enrichment'));
const Campaigns = lazy(() => import('./pages/campaigns/list'));
const Builder = lazy(() => import('./pages/campaigns/builder'));
const Audience = lazy(() => import('./pages/campaigns/audience'));
const Review = lazy(() => import('./pages/campaigns/review'));
const Monitor = lazy(() => import('./pages/campaigns/monitor'));
const Deliverability = lazy(() => import('./pages/deliverability'));
const Settings = lazy(() => import('./pages/settings'));
const Director = lazy(() => import('./pages/marketing-director'));
const Audit = lazy(() => import('./pages/audit'));
const NotFound = lazy(() => import('./pages/not-found'));

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<Login />} />
      <Route path="/forgot-password" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route index element={<Overview />} />
          <Route path="prospects" element={<Prospects />} />
          <Route path="prospects/:id" element={<ProspectDetail />} />
          <Route path="enrichment" element={<Enrichment />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="campaigns/:id/builder" element={<Builder />} />
          <Route path="campaigns/:id/audience" element={<Audience />} />
          <Route path="campaigns/:id/review" element={<Review />} />
          <Route path="campaigns/:id/monitor" element={<Monitor />} />
          <Route path="deliverability" element={<Deliverability />} />
          <Route path="settings" element={<Settings />} />
          <Route path="director" element={<Director />} />
          <Route path="audit" element={<Audit />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  );
}
